import { NAMED_VARIANT_EXPORT_HEADERS } from "./namedVariantsCsvExport";

const NEEDS_QUOTING = /[",\n\r]/;

function escapeCell(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = typeof value === "string" ? value : String(value);
  if (!NEEDS_QUOTING.test(s)) return s;
  return `"${s.replace(/"/g, '""')}"`;
}

function rowsToCsv(headers: readonly string[], rows: Array<Array<unknown>>): string {
  const lines = [headers.join(",")];
  for (const row of rows) {
    lines.push(row.map(escapeCell).join(","));
  }
  return lines.join("\n") + "\n";
}

/** Starter CSV for Named variants bulk import (header fields only). */
export const EXAMPLE_NAMED_VARIANTS_BULK_IMPORT_CSV = rowsToCsv(NAMED_VARIANT_EXPORT_HEADERS, [
  ["METAL_ROOF", "Metal roof upgrade", "Standing seam metal roof package", "draft"],
  ["PORCH_PKG", "Covered porch", "Standard 8ft covered porch add-on", "active"],
]);
